<!-- Separator -->
<div class="menu-item">
  <div class="menu-content pt-8 pb-1">
    <span class="menu-section text-muted text-uppercase fs-8 ls-1">
      <ng-container *ngIf="publisherContextId$ | async; else advHeader">
        {{'MENU.HEADER_PUBLISHER' | translate}}
      </ng-container>
      <ng-template #advHeader>
        {{'MENU.HEADER_ADVERTISER' | translate}}
      </ng-template>
    </span>
  </div>
</div>

  <!-- Publisher menu -->
<div *ngIf="publisherContextId$ | async as publisherId" class="menu-item">
  <a
    class="menu-link without-sub"
    [routerLink]="['publisher', publisherId, 'dashboard']"
    routerLinkActive="active"
    test-id="sideMenu.dashboard"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/duotune/abstract/abs027.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.DASHBOARD' | translate }}</span>
  </a>

  <a
    *ngIf="publisherAclService.canManagePlacements$ | async"
    class="menu-link without-sub"
    [routerLink]="['publisher', publisherId, 'slots', 'technical']"
    routerLinkActive="active"
    test-id="sideMenu.slots"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="ICON_PRODUCT"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.SLOTS' | translate }}</span>
  </a>

  <a
    *ngIf="isWhiteLabelShop"
    [routerLink]="['publisher', publisherId, 'advertisers']"
    routerLinkActive="active"
    class="menu-link without-sub"
    test-id="sideMenu.dashboard"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="ICON_ADVERTISERS_LIST"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.ADVERTISERS' | translate }}</span>
  </a>

  <a
    *ngIf="reportsAclService.canSeeReports$ | async"
    [routerLink]="['publisher', publisherId, 'reports']"
    routerLinkActive="active"
    class="menu-link without-sub"
    test-id="sideMenu.reports"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/duotune/graphs/gra001.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{'MENU.REPORTS' | translate}}</span>
  </a>

  <a
    *ngIf="feedAclService.canManageFeeds$ | async"
    class="menu-link without-sub"
    [routerLink]="['publisher', publisherId, 'feed']"
    routerLinkActive="active"
    test-id="sideMenu.feed"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/app/git.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{'MENU.FEED' | translate}}</span>
  </a>

  <!-- <a
    *ngIf="(publisherPaymentsAclService.canSeeSettlements$ | async) || (publisherPaymentsAclService.canSeePayMethods$ | async)"
    class="menu-link without-sub"
    [routerLink]="['publisher', publisherId, 'payments']"
    routerLinkActive="active"
    test-id="sideMenu.payments"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/app/money.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{'MENU.PAYMENTS' | translate}}</span>
  </a> -->

  <a
    *ngIf="pubDataFormAclService.canShowForm$ | async"
    class="menu-link without-sub"
    [routerLink]="['publisher', publisherId, 'settings']"
    routerLinkActive="active"
    test-id="sideMenu.settings"
  >
    <span class="menu-icon">
      <span
        inlineSVG="./assets/media/icons/duotune/communication/com011.svg"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.ACCOUNT_SETTINGS' | translate }}</span>
  </a>

  <a
    class="menu-link without-sub"
    [routerLink]="['publisher', publisherId, 'users']"
    routerLinkActive="active"
    test-id="sideMenu.users"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/oh-icons/users.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.SHOP_USERS' | translate }}</span>
  </a>

  <ng-container
    *ngIf="
      {
        canModerate: moderationAclService.canSeeModeration$ | async,
        isBannerSlotCreationEnabled: featureFlags.isBannerSlotCreationEnabled$ | async
      } as moderationPayload
    "
  >
    <a
      *ngIf="moderationPayload.canModerate && moderationPayload.isBannerSlotCreationEnabled"
      class="menu-link without-sub"
      [routerLink]="['publisher', publisherId, 'moderation']"
      routerLinkActive="active"
      test-id="sideMenu.moderation"
    >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/duotune/general/gen048.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
      <span class="menu-title">{{ 'MENU.MODERATION' | translate }}</span>
    </a>
  </ng-container>

  <a
    class="menu-link without-sub"
    [routerLink]="['publisher', publisherId, 'help']"
    routerLinkActive="active"
    test-id="sideMenu.knowledge-base"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="ICON_QUESTION_MARK"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.KNOWLEDGE_BASE' | translate }}</span>
  </a>
</div>

<!-- Advertiser menu -->
<div *ngIf="advertiserContextId$ | async as advertiserId" class="menu-item">
  <a
    class="menu-link without-sub"
    routerLink="/advertiser/{{advertiserId}}/campaigns"
    routerLinkActive="active"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/duotune/abstract/abs027.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.DASHBOARD' | translate }}</span>
  </a>

  <a
    class="menu-link without-sub"
    routerLink="/advertiser/{{advertiserId}}/reports"
    routerLinkActive="active"
    test-id="aside-menu.advertiser.reports-link"
    *ngIf="reportsAclService.canSeeReports$ | async"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/duotune/graphs/gra001.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title" translate="MENU.REPORTS"></span>
  </a>

  <a
    *ngIf="(advertiserPaymentsAclService.canSeeCreditLine$ | async) || (advertiserPaymentsAclService.canSeeInvoices$ | async)"
    class="menu-link without-sub"
    routerLink="/advertiser/{{advertiserId}}/payments"
    routerLinkActive="active"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/icons/duotune/finance/fin003.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title" translate="MENU.PAYMENTS"></span>
  </a>

  <a
    *ngIf="advDataFormAclService.canShowForm$ | async"
    class="menu-link without-sub"
    routerLink="/advertiser/{{advertiserId}}/settings"
    routerLinkActive="active"
  >
    <span class="menu-icon">
      <span
        inlineSVG="./assets/media/icons/duotune/communication/com011.svg"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.ACCOUNT_SETTINGS' | translate }}</span>
  </a>

  <a
    class="menu-link without-sub"
    routerLink="/advertiser/{{advertiserId}}/users"
    routerLinkActive="active"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="'./assets/media/oh-icons/users.svg'"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.ADV_USERS' | translate }}</span>
  </a>

  <a
    class="menu-link without-sub"
    [routerLink]="['advertiser', advertiserId, 'help']"
    routerLinkActive="active"
    test-id="sideMenu.knowledge-base"
  >
    <span class="menu-icon">
      <span
        [inlineSVG]="ICON_QUESTION_MARK"
        class="svg-icon svg-icon-2"
      ></span>
    </span>
    <span class="menu-title">{{ 'MENU.KNOWLEDGE_BASE' | translate }}</span>
  </a>
</div>
